module.exports = __webpack_public_path__ + "img/gdbank.1a1a28b0.png";